<div class="container">
    <div class="row align-items-center my-2">
        <div class="col">
            <h1>Financials</h1>
        </div>
        <div class="col-auto subscription-container">
            <label><input [formControl]="showSubs" type="checkbox"> Toon abo's</label>
        </div>
        @if (Functionalities.Subscriptions | hasFunctionality) {
            <div class="col-auto">
                <a [routerLink]="['/',Routenames.subscriptions]">Abonnementen</a>
            </div>
        }
    </div>
    <table class="table table-striped table-hover">
        <thead class="txtbold">
            <tr class="text-end">
                <td></td>
                <td></td>
                <td colspan="2">Previous period</td>
                <td colspan="2">Current period</td>
                <td colspan="6">Omzet excl. btw</td>
            </tr>
            <tr>
                <td><a [routerLink]="['/',Routenames.companies]" class="text-dark">Company</a></td>
                <td>Invoices</td>
                <td class="text-end" width="90">Hours</td>
                <td class="text-end" width="100">Revenue</td>
                <td class="text-end" width="90">Hours</td>
                <td class="text-end" width="100">Revenue</td>
                <td class="text-end" colspan="3">{{previousYearLabel}}</td>
                <td class="text-end" colspan="3">{{currentYearLabel}}</td>
            </tr>
        </thead>
        <tbody>
            @for (company of hourlyCompanies(); track company.id) {
                @if (company.prevmonth || company.curmonth || showSubs.value) {
                    <tr>
                        <td>
                            <div style="float: left">
                                <a [routerLink]="['/',Routenames.companies, company.id]">{{company.name}}</a>
                            </div>
                            @if (hasInvoice().indexOf(company.id) === -1) {
                                <button (click)="invoiceMonth(company.id)" [disabled]="invoicing" class="flright btn btn-primary">
                                    {{invoicing === company.id ? 'Factuur aanmaken...' : 'Factureer'}}
                                </button>
                            }
                        </td>
                        <td>
                            @for (invoice of visibleInvoices(); track invoice) {
                                @if (invoice.debtorId === company.afas_debtor_id) {
                                    <div
                                        [class.txtgreen]="(invoice.amtInvoice | number : '0.0-0') === (invoice.betaald | number : '0.0-0')"
                                        [class.txtred]="invoice.betaald !== invoice.amtInvoice && invoice.betaald > 0"
                                        title="{{invoice.description}}">
                                        <div style="float: left; width: 100px;">
                                            {{invoice.status}}
                                        </div>
                                        <div style="float: left; width: 70px;">
                                            {{invoice.nookPieceDate | date : 'd MMM'}}
                                        </div>
                                        <div style="float: left; width: 50px;">
                                            {{invoice.invoiceNr}}
                                        </div>
                                        <div class="text-end">
                                            @if (invoice.betaald === invoice.amtInvoice || invoice.betaald === 0) {
                                                {{invoice.totaalExclBtw | currency : 'EUR' : 'symbol' : '0.0-0'}}
                                            }
                                            @if (invoice.betaald !== invoice.amtInvoice && invoice.betaald > 0) {
                                                {{invoice.amtInvoice | currency : 'EUR' : 'symbol' : '0.0-0'}} incl. !==
                                                <span class="line-through">
                                                {{invoice.betaald | currency : 'EUR' : 'symbol' : '0.0-0'}},
                                            </span><br>
                                                {{invoice.totaalExclBtw | currency : 'EUR' : 'symbol' : '0.0-0'}} excl.
                                            }
                                        </div>
                                    </div>
                                }
                            }
                        </td>
                        <td class="text-end">
                            <a [queryParams]="{year: currentYear, period: previousPeriod, userId: 0, companyId: company.id}" [routerLink]="['/',Routenames.reports]">
                                {{company.prevmonth ? utils.decimalTime(company.prevmonth) : ''}}
                            </a>
                        </td>
                        <td class="text-end">{{company.prevmonth * hourlyRate | currency : 'EUR' : 'symbol' : '0.0-0'}}</td>
                        <td class="text-end">
                            <a [queryParams]="{year: currentYear, period: currentPeriod, userId: 0, companyId: company.id}" [routerLink]="['/',Routenames.reports]">
                                {{company.curmonth ? utils.decimalTime(company.curmonth) : ''}}
                            </a>
                        </td>
                        <td class="text-end">{{company.curmonth * hourlyRate | currency : 'EUR' : 'symbol' : '0.0-0'}}</td>
                        <td class="text-end" colspan="3">{{previousYearRevenueByDebtor().get(company.afas_debtor_id) | currency : 'EUR' : 'symbol' : '0.0-0'}}</td>
                        <td class="text-end" colspan="3">{{currentYearRevenueByDebtor().get(company.afas_debtor_id) | currency : 'EUR' : 'symbol' : '0.0-0'}}</td>
                    </tr>
                }
            }
            <tr class="txtbold">
                <td>Totals</td>
                <td class="text-end">
                    @for (date of visibleInvoiceDates(); track date) {
                        <span [style.font-weight]="400">{{date | date : 'EEEE d MMM yyyy'}}:</span>
                        {{visibleInvoices() | filter : date : 'nookPieceDate' | sum : 'totaalExclBtw' | currency : 'EUR' : 'symbol' : '0.0-0'}}
                        <br>
                    }
                </td>
                <td class="text-end">{{utils.decimalTime(utils.sumProps(hourlyCompanies(), 'prevmonth'))}}</td>
                <td class="text-end">&euro; {{utils.sumProps(hourlyCompanies(), 'prevmonth') * hourlyRate | number:'1.2-2'}}</td>
                <td class="text-end">{{utils.decimalTime(utils.sumProps(hourlyCompanies(), 'curmonth'))}}</td>
                <td class="text-end">&euro; {{utils.sumProps(hourlyCompanies(), 'curmonth') * hourlyRate | number:'1.2-2'}}</td>
                <td class="text-end" colspan="3">{{previousYearInvoices() | sum : 'totaalExclBtw' | currency : 'EUR' : 'symbol' : '0.0-0'}}</td>
                <td class="text-end" colspan="3">{{currentYearTotal() | currency : 'EUR' : 'symbol' : '0.0-0'}}</td>
            </tr>
        </tbody>
    </table>

    <table class="table table-striped table-hover">
        <thead>
            <tr class="txtbold text-end">
                <td colspan="2"></td>
                <td colspan="2">Previous period</td>
                <td colspan="2">Current period</td>
                <td colspan="4">{{previousYearLabel}}</td>
                <td colspan="4">{{currentYearLabel}}</td>
            </tr>
            <tr class="txtbold">
                <td colspan="2"><a [routerLink]="['/',Routenames.users]" class="text-dark">Medewerker</a></td>
                <td class="text-end">Uren</td>
                <td class="text-end">Kosten</td>
                <td class="text-end">Uren</td>
                <td class="text-end">Kosten</td>
                <td class="text-end" width="150">Intern</td>
                <td class="text-end" width="50">Groundbirds</td>
                <td class="text-end" width="50">Extern</td>
                <td class="text-end" width="80" title="Aandeel van het totaal aantal externe uren dat jaar">Extern %</td>
                <td class="text-end" width="150">Intern</td>
                <td class="text-end" width="50">Groundbirds</td>
                <td class="text-end" width="50">Extern</td>
                <td class="text-end" width="80" title="Aandeel van het totaal aantal externe uren dat jaar">Extern %</td>
            </tr>
        </thead>
        <tbody>
            @for (employee of filteredUsers; track employee) {
                <tr>
                    <td colspan="2"><a [routerLink]="['/',Routenames.users, employee.id]">{{employee.name}}</a></td>
                    <td class="text-end">
                        <a [queryParams]="{year: currentYear, period: previousPeriod, userId: employee.id, companyId: 0}" [routerLink]="['/',Routenames.reports]">
                            {{employee.prev_month ? utils.decimalTime(employee.prev_month) : ''}}
                        </a>
                    </td>
                    <td class="text-end">{{employee.period_costs | currency : 'EUR' : 'symbol' : '0.0-0'}}</td>
                    <td class="text-end">
                        <a [queryParams]="{year: currentYear, period: previousPeriod, userId: employee.id, companyId: 0}" [routerLink]="['/',Routenames.reports]">
                            {{employee.cur_month ? utils.decimalTime(employee.cur_month) : ''}}
                        </a>
                    </td>
                    <td class="text-end">{{employee.period_costs | currency : 'EUR' : 'symbol' : '0.0-0'}}</td>
                    <td class="text-end">{{formatPercentage(hoursPercentage(previousYearHoursByUser().get(employee.id), 'internal'))}}</td>
                    <td class="text-end">{{formatPercentage(hoursPercentage(previousYearHoursByUser().get(employee.id), 'groundbirds'))}}</td>
                    <td class="text-end">{{formatPercentage(hoursPercentage(previousYearHoursByUser().get(employee.id), 'external'))}}</td>
                    <td class="text-end">{{formatPercentage(externalShare(filteredUsers, previousYearHoursByUser(), employee))}}</td>
                    <td class="text-end">{{formatPercentage(hoursPercentage(currentYearHoursByUser().get(employee.id), 'internal'))}}</td>
                    <td class="text-end">{{formatPercentage(hoursPercentage(currentYearHoursByUser().get(employee.id), 'groundbirds'))}}</td>
                    <td class="text-end">{{formatPercentage(hoursPercentage(currentYearHoursByUser().get(employee.id), 'external'))}}</td>
                    <td class="text-end">{{formatPercentage(externalShare(filteredUsers, currentYearHoursByUser(), employee))}}</td>
                </tr>
            }
            <tr class="txtbold">
                <td colspan="2">Totaal uren (%)</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="text-end">{{formatPercentage(hoursTotalPercentage(filteredUsers, previousYearHoursByUser(), 'internal'))}}</td>
                <td class="text-end">{{formatPercentage(hoursTotalPercentage(filteredUsers, previousYearHoursByUser(), 'groundbirds'))}}</td>
                <td class="text-end">{{formatPercentage(hoursTotalPercentage(filteredUsers, previousYearHoursByUser(), 'external'))}}</td>
                <td class="text-end">{{hoursTotal(filteredUsers, previousYearHoursByUser(), 'external') ? '100%' : ''}}</td>
                <td class="text-end">{{formatPercentage(hoursTotalPercentage(filteredUsers, currentYearHoursByUser(), 'internal'))}}</td>
                <td class="text-end">{{formatPercentage(hoursTotalPercentage(filteredUsers, currentYearHoursByUser(), 'groundbirds'))}}</td>
                <td class="text-end">{{formatPercentage(hoursTotalPercentage(filteredUsers, currentYearHoursByUser(), 'external'))}}</td>
                <td class="text-end">{{hoursTotal(filteredUsers, currentYearHoursByUser(), 'external') ? '100%' : ''}}</td>
            </tr>
            <tr>
                <td colspan="2">Algemene kosten (10%)</td>
                <td class="text-end"></td>
                <td class="text-end">{{generalCosts | currency : 'EUR' : 'symbol' : '0.0-0'}}</td>
                <td class="text-end"></td>
                <td class="text-end">{{generalCosts | currency : 'EUR' : 'symbol' : '0.0-0'}}</td>
            </tr>
            <tr class="txtbold">
                <td colspan="2">Subtotaal kosten</td>
                <td class="text-end"></td>
                <td class="text-end">{{(utils.sumProps(filteredUsers, 'period_costs') + generalCosts) | currency : 'EUR' : 'symbol' : '0.0-0'}}</td>
                <td class="text-end"></td>
                <td class="text-end">{{(utils.sumProps(filteredUsers, 'period_costs') + generalCosts) | currency : 'EUR' : 'symbol' : '0.0-0'}}</td>
            </tr>
            <tr class="txtbold">
                <td colspan="2">Kosten naar ratio</td>
                <td class="text-end"></td>
                <td class="text-end">{{(utils.sumProps(filteredUsers, 'period_costs') + generalCosts) | currency : 'EUR' : 'symbol' : '0.0-0'}}</td>
                <td class="text-end">{{daysElapsedInPeriod}} dgn</td>
                <td class="text-end">{{((daysElapsedInPeriod / 20) * (utils.sumProps(filteredUsers, 'period_costs') + generalCosts)) | currency : 'EUR' : 'symbol' : '0.0-0'}}</td>
            </tr>
            <tr class="txtbold">
                <td colspan="2">Totaal</td>
                <td class="text-end"></td>
                <td class="text-end">
                    {{(utils.sumProps(hourlyCompanies(), 'prevmonth') * hourlyRate - utils.sumProps(filteredUsers, 'period_costs') - generalCosts) | currency : 'EUR' : 'symbol' : '0.0-0'}}
                </td>
                <td class="text-end"></td>
                <td class="text-end">
                    {{(utils.sumProps(hourlyCompanies(), 'curmonth') * hourlyRate - ((daysElapsedInPeriod / 20) * (utils.sumProps(filteredUsers, 'period_costs') + generalCosts))) | currency : 'EUR' : 'symbol' : '0.0-0'}}
                </td>
            </tr>
        </tbody>
    </table>
</div>
